import ViewTrainerAttendance from '../commonfile/ViewTrainerAttendance'

const ZoneManagerViewTraAtd = () => {
  return (
   <>
   
    <ViewTrainerAttendance />
   </>
  )
}

export default ZoneManagerViewTraAtd